var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('details',[_c('summary',[_c('p',{staticClass:"list2"},[_vm._v(_vm._s(_setup.t('widget_info_text.target_filter')))])]),_c('p',{staticClass:"text list"},[_vm._v(" "+_vm._s(_setup.t('widget_info_text.target_filter_txt'))+" "),_c('img',{attrs:{"src":"images/info/editTargets.jpg"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }